export default "__VITE_ASSET__CTZv9lsZ__"